import React from "react";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { Tooltip, Fade } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  FaDownload,
  FaEllipsisV,
  FaEye,
  FaSearch,
  FaChevronDown,
} from "react-icons/fa";

const DashboardTable = ({
  handleSort,
  sortConfig,
  toggleSearchBar,
  showSearchBar,
  searchQuery,
  sortedReviews,
  setSearchQuery,
  ViewReport,
  DownloadReport,
  handleSelect,
  editReview,
  manageInvitation,
  toggleReviewActiveStatus,
}) => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user.data.role.role);
  return (
    <div>
      <table className="table table-striped ">
        <thead className="table-head ">
          <tr>
            <th>
              <span className="d-flex justify-content-between align-items-center">
                <span
                  className="cursor-pointer"
                  onClick={() => handleSort("title")}
                >
                  Name
                  {sortConfig.key === "title" && (
                    <FaChevronDown
                      className={`${sortConfig.direction === "desc" ? "rotate-icon" : ""
                        }`}
                    />
                  )}
                </span>

                <span
                  className="d-flex align-items-center cursor-pointer "
                  onClick={toggleSearchBar}
                  title={showSearchBar ? "hide search" : "show search"}
                >
                  {/* Dropdown Arrow */}
                  <FaChevronDown
                    className={`dropdown-arrow me-1 ${showSearchBar ? "rotate-icon" : ""
                      }`}
                  />

                  {/* Search Icon */}
                  <FaSearch />
                </span>
              </span>
            </th>
            <th
              className="heading-table cursor-pointer"
              onClick={() => handleSort("review_type.description")}
            >
              Type
              {sortConfig.key === "review_type.description" && (
                <FaChevronDown
                  className={`${sortConfig.direction === "desc" ? "rotate-icon" : ""
                    }`}
                />
              )}
            </th>
            <th
              className="heading-table cursor-pointer"
              onClick={() => handleSort("current_stage.label")}
            >
              {userData == "admin" ? "Created by" : "Stage"}
              {sortConfig.key === "current_stage.label" && (
                <FaChevronDown
                  className={`${sortConfig.direction === "desc" ? "rotate-icon" : ""
                    }`}
                />
              )}
            </th>
            <th
              className="heading-table cursor-pointer"
              onClick={() => handleSort("created_at")}
            >
              Start Date
              {sortConfig.key === "created_at" && (
                <FaChevronDown
                  className={`${sortConfig.direction === "desc" ? "rotate-icon" : ""
                    }`}
                />
              )}
            </th>
            <th
              className="heading-table cursor-pointer"
              onClick={() => handleSort("tentative_completion_date")}
            >
              End Date
              {sortConfig.key === "tentative_completion_date" && (
                <FaChevronDown
                  className={`${sortConfig.direction === "desc" ? "rotate-icon" : ""
                    }`}
                />
              )}
            </th>
            <th className="heading-table">Action</th>
          </tr>
        </thead>

        {showSearchBar && (
          <span
            className="search-bar-wrapper"
            style={{
              marginLeft: "15px",
              width: "90%",
              bottom: "10px",
            }}
          >
            <form>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </form>

            <FaSearch className="search-clear-icon" style={{ top: "26px" }} />
          </span>
        )}

        <tbody>
          {sortedReviews &&
            sortedReviews?.map((review, index) => (
              <tr key={index} className="table-row">
                <td className="title-column cursor-pointer">
                  <Tooltip
                    title={review.title}
                    placement="top"
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 500 }}
                    arrow
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, -10],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <div
                      className="title-text"
                      onClick={userData === "admin" ? null : () => {
                        localStorage.setItem("pageId", 1101);
                        localStorage.setItem("studyId", review.id);
                        navigate("/searchabstracts");
                      }}
                    >
                      {review.title}
                    </div>
                  </Tooltip>
                  <div className="icon-container">
                    <FaEye
                      color="grey"
                      size={15}
                      style={{ marginRight: 10 }}
                      onClick={() => {

                        localStorage.setItem("studyId", review.id);
                        ViewReport(review.review_type_id, false);
                      }}
                    />
                    <FaDownload
                      color="grey"
                      size={15}
                      onClick={() =>
                        DownloadReport(review.review_type_id, true, review.id)
                      }
                    />
                  </div>
                </td>

                <td className="other-column">
                  {review.review_type.description}
                </td>
                {userData == "admin" ?

                  <td className="other-column">
                    {review.owner.name}
                  </td>
                  :
                  <td className="other-column" style={{ textAlign: "center" }}>
                    {review.final_completion_date !== null ? (
                      <span className="bg-success px-2 py-1 text-light rounded">
                        Completed
                      </span>
                    ) : review.current_stage.label === "Full Text Screening" ? (
                      <span className="bg-light-blue px-2 py-1 text-light rounded">
                        {review.current_stage.label}
                      </span>
                    ) : (
                      <span className="bg-light-grey px-2 py-1 text-light rounded">
                        {review.current_stage.label}
                      </span>
                    )}
                  </td>}


                <td className="other-column">
                  {review.created_at.slice(0, 10)}
                </td>
                <td className="other-column">
                  {review.final_completion_date === ""
                    ? review.final_completion_date
                    : review.tentative_completion_date}
                </td>
                <td>
                  <div className="Actions--container">
                    <Dropdown
                    // onSelect={handleSelect}
                    >
                      <Dropdown.Toggle
                        variant="custom"
                        id="dropdownMenuButton2"
                      >
                        <span>
                          <FaEllipsisV />
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        className="actions--dropdown--menu"
                        style={{ zIndex: 1 }}
                      >
                        <Dropdown.Item onClick={() => editReview(review.id)}>
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={(e) => manageInvitation(review.id)}
                        >
                          Edit Invitation
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() =>
                            toggleReviewActiveStatus(review.id, "inactive")
                          }
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardTable;
